import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import history from '../../common/history';
import { WBS_isNodeValid } from '../common/redux/validators';
import NotValidWbsCard from './NotValidWbsCard';
import ControlAccount from '../ca/ControlAccount';

export class ControlAccountView extends Component 
{

  static propTypes = {
    wbs: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

   constructor(props) 
   {
    super(props);
    this.state = {
      projectValid:true
    }
    // this.firstValidations();
  }

  /*Valid a especific node */
  isNodeValid(node)
  {
    return WBS_isNodeValid(node);
  }

  componentDidMount(){
    this.firstValidations();
  }


  firstValidations()
  {
    //Si entra a la pagina sin saber que project está viendo lo manda a /
    if(!this.props.project || !this.props.project.project)
    {
      history.push("/");
      return;
    }

    //Obtenemos el árbol completo
    this.props.actions.fetchWbs(this.props.project.project)
    .then(res=>{
      let projectValid =  this.isNodeValid(res.tree)
      this.setState({tree:[res.tree], projectValid:projectValid});
    });
  }

  render() {
    return (
      <div className="wbs-control-account-view">
        {
          //Si es valido el proyecto entonces mostrarlo.
          this.state.projectValid?
          (
            <ControlAccount project={this.props.project} project_status={this.props.project_status} />
          ):
          (
            <NotValidWbsCard/>
          )
        }
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    wbs: state.wbs,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ControlAccountView);



// WEBPACK FOOTER //
// ./src/features/wbs/ControlAccountView.js